import { buildLoader } from '../util/GenericLoader';
import { getModbusTemplatesAction } from '../../redux/actions/modbus';

export default buildLoader(getModbusTemplatesAction);
